import { createSlice } from '@reduxjs/toolkit';
import type { OtherPlayerResponse, ProfileError, ProfileResponse } from '../api/profile.types';
import { fetchOtherPlayer, fetchProfile, updateProfile } from './profile.thunk';

interface ProfileState {
  data: ProfileResponse | null;
  otherPlayer: OtherPlayerResponse | null;
  loading: boolean;
  error: ProfileError | null;
  otherPlayerLoading: boolean;
  otherPlayerError: ProfileError | null;
}

const initialState: ProfileState = {
  data: null,
  otherPlayer: null,
  loading: false,
  error: null,
  otherPlayerLoading: false,
  otherPlayerError: null,
};

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    clearOtherPlayer: (state) => {
      state.otherPlayer = null;
      state.otherPlayerError = null;
      state.otherPlayerLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = {
          message: (action.payload as string) || 'Unknown error',
          code: 500,
        };
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        if (state.data) {
          state.data.player = {
            ...state.data.player,
            ...action.payload.player,
          };
        }
      })
      .addCase(fetchOtherPlayer.pending, (state) => {
        state.otherPlayerLoading = true;
        state.otherPlayerError = null;
      })
      .addCase(fetchOtherPlayer.fulfilled, (state, action) => {
        state.otherPlayerLoading = false;
        state.otherPlayer = action.payload;
      })
      .addCase(fetchOtherPlayer.rejected, (state, action) => {
        state.otherPlayerLoading = false;
        state.otherPlayerError = {
          message: (action.payload as string) || 'Unknown error',
          code: 500,
        };
      });
  },
});
export const { clearOtherPlayer } = profileSlice.actions;
export default profileSlice.reducer;
